import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import {
  getFormCounts,
  getFormIdsToHide,
  getForms,
  hideForm,
  showForm,
} from "reduxSlices/surveyRecipientTableSlice"
import { FormIcon } from "shared/icons"
import { Checkbox } from "shared/checkboxes"

const FormList = ({ className = "" }) => {
  const dispatch = useDispatch()

  const forms = useSelector(getForms, isEqual)
  const formIdsToHide = useSelector(getFormIdsToHide, isEqual)
  const formCounts = useSelector(getFormCounts, isEqual)

  const isFormVisible = (id) => !formIdsToHide.includes(id)

  const toggleFormVisibility = (id) => () => {
    const updateFunction = isFormVisible(id) ? hideForm : showForm

    dispatch(updateFunction(id))
  }

  return (
    <div className={clsx(className, "flex flex-col gap-2")}>
      {
        forms.map((form) => (
          <div
            key={form.id}
            className="flex gap-2 items-center p-2 rounded-md border border-lightgray-3 cursor-pointer"
            onClickCapture={toggleFormVisibility(form.id)}
          >
            <FormIcon form={form} className="h-6 w-6 shrink-0" />
            <div className="grow flex items-center gap-1">
              <span className="text-sm font-medium">{form.title}</span>
              <span className="text-xs text-dark"> ({formCounts[form.id]})</span>
            </div>
            <Checkbox
              className="shrink-0"
              value={isFormVisible(form.id)}
              onChange={toggleFormVisibility(form.id)}
            />
          </div>
        ))
      }
    </div>
  )
}

FormList.propTypes = {
  className: types.string,
}

export default FormList
